import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  // endpointString: randomizeString(),
  salesCode: "",
  email: "",
  phoneNumber: "",
  password: "",
  idNumber: "",
  name: "",
  bloodType: "",
  religion: "",
  gender: "",
  birthPlaceBirthday: "",
  province: "",
  city: "",
  district: "",
  village: "",
  rtrw: "",
  occupation: "",
  expiryDate: "",
  nationality: "1",
  maritalStatus: "",
  address: "",
  rt: "",
  rw: "",
  postalCodeId: "",
  placeOfBirth: "",
  birthday: "",
  bankName: "",
  withdrawalBank: "",
  account: "",
  numberAccount: "",
  npwp: "",
  mothersName: "",
  lastEducation: "",
  incomeTotalInYear: "",
  incomeSource: "",
  investGoal: "",
  rdnBank: "",
  verifBank: false,
  bankNpwp: "",
  bankAgreement: false,
  jobs: "",
  institution: "",
  businessField: "",
  position: "",
  institutionAddress: "",
  institutionCity: "",
  institutionPhoneNumber: "",
  postalCode: "",
  haveFamilyInHPS: "2",
  haveFamilyInStockExchange: "2",
  instruksiAS: "1",
  accountExceptMainBank: "2",
  customerSign: "",
  photoKTP: "",
  photoSelfie: "",
  namePOT: "",
  relationshipPOT: "",
  jobsPOT: "",
  businessFieldPOT: "",
  positionPOT: "",
  institutionPOT: "",
  institutionPhonePOT: "",
  agreement: false,
  POTincomeTotalInYear: "",
  spouseName: "",
  recordID: "",
};

export const kycSlice = createSlice({
  name: "register",
  initialState,
  reducers: {
    setRegister: (state, action) => {
      action?.payload &&
        Object.entries(action?.payload)?.forEach(([key, value]) => {
          if (value !== undefined) state[key] = value;
        });
    },
    resetRegister: (state) => Object.assign(state, initialState),
  },
});

// Action creators are generated for each case reducer function
export const { setRegister, resetRegister } = kycSlice.actions;

export default kycSlice.reducer;
